import { fetchConfig } from '@theme/utilities';

/**
 * Slaat de keuze "Slinger maken" direct op als winkelmand-eigenschap,
 * zodat de keuze bewaard blijft als de winkelmand opnieuw wordt opgebouwd
 * of als de klant via een snelle betaalknop afrekent.
 */
const VELDNAAM = 'attributes[Slinger maken]';

document.addEventListener('change', async (event) => {
  const veld = event.target;
  if (!(veld instanceof HTMLInputElement) || veld.type !== 'checkbox' || veld.name !== VELDNAAM) return;

  try {
    const antwoord = await fetch(
      Theme.routes.cart_update_url,
      fetchConfig('json', {
        body: JSON.stringify({ attributes: { 'Slinger maken': veld.checked ? 'Ja' : '' } }),
      })
    );
    if (!antwoord.ok) throw new Error(`Status ${antwoord.status}`);
  } catch (fout) {
    console.warn('[slinger-maken] Keuze niet opgeslagen:', fout);
  }
});

/**
 * Zitten er geen losse items meer in de winkelmand terwijl de keuze nog op "Ja" staat,
 * dan zet het thema een verborgen veld met data-slinger-wissen neer. Wis de keuze dan direct,
 * zodat hij ook bij een snelle betaalknop niet in de bestelling blijft staan.
 */
let bezigMetWissen = false;

async function wisKeuzeIndienNodig() {
  const veld = document.querySelector('input[data-slinger-wissen]');
  if (!veld || bezigMetWissen) return;
  bezigMetWissen = true;
  try {
    const antwoord = await fetch(
      Theme.routes.cart_update_url,
      fetchConfig('json', { body: JSON.stringify({ attributes: { 'Slinger maken': '' } }) })
    );
    if (!antwoord.ok) throw new Error(`Status ${antwoord.status}`);
    document.querySelectorAll('input[data-slinger-wissen]').forEach((el) => el.removeAttribute('data-slinger-wissen'));
  } catch (fout) {
    console.warn('[slinger-maken] Keuze niet gewist:', fout);
  } finally {
    bezigMetWissen = false;
  }
}

wisKeuzeIndienNodig();
new MutationObserver(wisKeuzeIndienNodig).observe(document.documentElement, { childList: true, subtree: true });
